#@import GliveBooking.Presenters.Calendar
#@export GliveBooking.Views.Calendar

class GliveBooking.Views.Calendar extends BookingV2.Views.Calendar

  module: 'glive-booking'

  presenter: GliveBooking.Presenters.Calendar
